import { useEffect, useState } from "react";
import { DesignerTheme, getAppliedTheme, watchAppliedTheme } from "../utility/designer-theme";

/**
 * The painted light/dark theme, re-rendering the caller when it flips.
 *
 * Most of the designer never needs this: its styles are tokens, and tokens follow the
 * `data-theme` attribute without React. It is for output that bakes a colour in at render time.
 */
const useAppliedTheme = (): DesignerTheme => {
  const [theme, setTheme] = useState<DesignerTheme>(getAppliedTheme);

  useEffect((): (() => void) => {
    // The theme may already have flipped between the first render and this effect.
    setTheme(getAppliedTheme());
    return watchAppliedTheme(setTheme);
  }, []);

  return theme;
};

export default useAppliedTheme;
